
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import FormField from '@/components/forms/FormField.vue';

import { Actions, Getters } from '@/store/enums/SystemEnums';

/**
 * TODO:
 *
 * Recreate this component when the backend start creating auto-generated
 * passwords
 */

export default defineComponent({
  name: 't2o-countries-select',
  components: {
    FormField,
  },
  emits: ['change', 'close'],
  props: {
    containerClass: {
      default: 'col-lg-4',
      type: String,
    },
    name: {
      default: 'country',
      type: String,
    },
    label: {
      default: 'Country',
      type: String,
    },
    value: {
      default: null,
      type: String,
    },
    showLabel: {
      default: true,
      type: Boolean,
    },
  },
  mounted() {
    this.listAllCountries();
  },
  computed: {
    ...mapGetters({ countries: Getters.GET_ALL_COUNTRIES }),
  },
  methods: {
    ...mapActions({
      listAllCountries: Actions.LIST_ALL_COUNTRIES,
    }),

    handleChange(value) {
      this.$emit('change', value);
    },
    handleClose() {
      this.$emit('close');
    },
  },
});
